import { OPEN_ACCORDION_SECTION, CLOSE_ACCORDION_SECTION, EXPAND_ACCORDION, CLOSE_ACCORDION } from '../lib/types';

// Action Creators
export const openAccordionSection = (sectionName) => (dispatch) => {
  dispatch({
    type: OPEN_ACCORDION_SECTION,
    payload: sectionName,
  });
};

export const closeAccordionSection = (sectionName) => (dispatch) => {
  dispatch({
    type: CLOSE_ACCORDION_SECTION,
    payload: sectionName,
  });
};

export const expandAccordionAction = (expand) => (dispatch) => {
  dispatch({
    type: EXPAND_ACCORDION,
    payload: expand,
  });
};

export const closeEntireAccordion = () => (dispatch) => {
  dispatch({
    type: CLOSE_ACCORDION,
    payload: null,
  });
};



// WEBPACK FOOTER //
// ./src/actions/accordion-actions.js